import React, {useEffect, useState} from "react";
import {Typography} from "@mui/material";
import css_buttons from "../Common/css/CCButton.module.scss";
import css_typography from "../Common/css/Typography.module.scss";
import enterpriseObjectClassFactory from "../../eoec/EnterpriseObjectClassFactory";
import EnterpriseObject from "../../eoec/eo/EnterpriseObject";
import EnterpriseComponent from "../../eoec/ec/EnterpriseComponent";
import {prepareBuffer} from "../../util/Buffer";
import EventBus from "../../util/EventBus";
import BillConfigurationFormApplet from "../../eoec/applet/impl/BillConfiguration/BillConfigurationFormApplet";
import BillSubscriptionTableApplet from "../../eoec/applet/impl/BillConfiguration/BillSubscriptionTableApplet";
import BillSubscriptionCommunicationTableApplet from "../../eoec/applet/impl/BillConfiguration/BillSubscriptionCommunicationTableApplet";
import CCButton from "../Common/CCButton";

export default function BillConfiguration() {
    const [backgroundOperation, setBackgroundOperation] = useState<boolean>(false);
    const [billConfigurationEnterpriseObject] = useState(() => enterpriseObjectClassFactory("BillConfiguration") as EnterpriseObject);
    const [billConfigurationBuffer, setBillConfigurationBuffer] = React.useState<Map<string, any>>(new Map<string, any>());
    const [showConfigurationEditor, setShowConfigurationEditor] = React.useState(false);
    const [mode, setMode] = useState<string>("New");

    function enterpriseComponentLoadStartedListener(ec: EnterpriseComponent) {
        setBackgroundOperation(true)
    }

    function enterpriseComponentLoadCompletedListener(ec: EnterpriseComponent) {
        let b:Map<string, any>[] = prepareBuffer(ec)

        if (b.length > 0) {
            setMode("Edit")
            setBillConfigurationBuffer(b[0]);
        } else {
            setMode("New")
            setBillConfigurationBuffer(new Map<string, any>());
        }
        setBackgroundOperation(false)
    }

    function enterpriseComponentInsertCompletedListener(ec: EnterpriseComponent) {
        ec.invalidate();
    }

    function enterpriseComponentInvalidListener(ec: EnterpriseComponent) {
        billConfigurationEnterpriseObject.getEnterpriseComponent("BillConfiguration")?.setIDOCRequest("v1.BillConfiguration-001");
        billConfigurationEnterpriseObject.getEnterpriseComponent("BillConfiguration")?.setIDOCResponse("v1.BillConfiguration-001");
        billConfigurationEnterpriseObject.getEnterpriseComponent("BillConfiguration")?.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        billConfigurationEnterpriseObject.getEnterpriseComponent("BillConfiguration")?.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        billConfigurationEnterpriseObject.getEnterpriseComponent("BillConfiguration")?.executeQuery(1, 1);
    }

    function enterpriseComponentValueChanged(ec: EnterpriseComponent) {
        let b:Map<string, any>[] = prepareBuffer(ec)

        setBillConfigurationBuffer(b[0]);
    }

    function onCancelHandler(e: MouseEvent) {
        setShowConfigurationEditor(false);
    }

    useEffect(() => {
        EventBus.components.addListener("bill-configuration-form-applet-cancel", onCancelHandler);
        EventBus.components.addListener("bill-configuration-form-applet-save", onCancelHandler);

        billConfigurationEnterpriseObject.getEnterpriseComponent("BillConfiguration")?.addValueChangedListener(enterpriseComponentValueChanged);
        billConfigurationEnterpriseObject.getEnterpriseComponent("BillConfiguration")?.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        billConfigurationEnterpriseObject.getEnterpriseComponent("BillConfiguration")?.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        billConfigurationEnterpriseObject.getEnterpriseComponent("BillConfiguration")?.addInsertCompletedListener(enterpriseComponentInsertCompletedListener);
        billConfigurationEnterpriseObject.getEnterpriseComponent("BillConfiguration")?.addInvalidListener(enterpriseComponentInvalidListener);

        billConfigurationEnterpriseObject.getEnterpriseComponent("BillConfiguration")?.setIDOCRequest("v1.BillConfiguration-001");
        billConfigurationEnterpriseObject.getEnterpriseComponent("BillConfiguration")?.setIDOCResponse("v1.BillConfiguration-001");
        billConfigurationEnterpriseObject.getEnterpriseComponent("BillConfiguration")?.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        billConfigurationEnterpriseObject.getEnterpriseComponent("BillConfiguration")?.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        billConfigurationEnterpriseObject.getEnterpriseComponent("BillConfiguration")?.executeQuery(1, 1);

        return () => {
            EventBus.components.removeListener("bill-configuration-form-applet-cancel", onCancelHandler);
            EventBus.components.removeListener("bill-configuration-form-applet-save", onCancelHandler);

            billConfigurationEnterpriseObject.getEnterpriseComponent("BillConfiguration")!.removeValueChangedListener(enterpriseComponentValueChanged);
            billConfigurationEnterpriseObject.getEnterpriseComponent("BillConfiguration")!.removeLoadStartedListener(enterpriseComponentLoadStartedListener);
            billConfigurationEnterpriseObject.getEnterpriseComponent("BillConfiguration")!.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener);
            billConfigurationEnterpriseObject.getEnterpriseComponent("BillConfiguration")!.removeInsertCompletedListener(enterpriseComponentInsertCompletedListener);
            billConfigurationEnterpriseObject.getEnterpriseComponent("BillConfiguration")!.removeInvalidListener(enterpriseComponentInvalidListener);
        }
    }, [billConfigurationEnterpriseObject]);

    function renderEditor() {
        if (showConfigurationEditor && mode === "New") {
            return <BillConfigurationFormApplet enterpriseComponent={billConfigurationEnterpriseObject.getEnterpriseComponent("BillConfiguration")} defaultAction="New"/>
        } else if (showConfigurationEditor) {
            return <BillConfigurationFormApplet enterpriseComponent={billConfigurationEnterpriseObject.getEnterpriseComponent("BillConfiguration")} defaultAction="Edit" />
        }
    }

    return (
        <div style={{display: "flex", flexDirection: "column", flexGrow: 1, width: "100%"}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "30px", width: "100%", marginBottom: "5px", marginRight: "20px"}}>
                <div style={{width: "100%"}}>
                    <Typography style={{fontSize: "22px", fontWeight: "500", color: "#1498D8"}}>Bill Configuration</Typography>
                </div>
            </div>
            <div style={{border: "1px solid #EDEFF3", width: "calc(100% - 22px)", padding: "10px 10px 10px 10px", borderRadius: "5px"}}>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "30px", width: "100%"}}>
                    <div style={{width: "100px"}}>
                        <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>User Name:</Typography>
                    </div>
                    <div style={{width: "400px"}}>
                        <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{billConfigurationBuffer.get("UserName") ?? "--"}</Typography>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "30px", width: "100%"}}>
                    <div style={{width: "100px"}}>
                        <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>Password:</Typography>
                    </div>
                    <div style={{width: "400px"}}>
                        <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{billConfigurationBuffer.get("Password") ?? "--"}</Typography>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "30px", width: "100%"}}>
                    <div style={{width: "100px"}}>
                        <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>Organization ID:</Typography>
                    </div>
                    <div style={{width: "400px"}}>
                        <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{billConfigurationBuffer.get("OrganizationID") ?? "--"}</Typography>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "30px", width: "100%"}}>
                    <div style={{width: "100px"}}>
                        <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>Developer Key:</Typography>
                    </div>
                    <div style={{width: "400px"}}>
                        <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{billConfigurationBuffer.get("DeveloperKey") ?? "--"}</Typography>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "30px", width: "100%"}}>
                    <div style={{width: "100px"}}>
                        <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>V2 API Url:</Typography>
                    </div>
                    <div style={{width: "400px"}}>
                        <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{billConfigurationBuffer.get("V2APIUrl") ?? "--"}</Typography>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "30px", width: "100%"}}>
                    <div style={{width: "100px"}}>
                        <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>V3 API Url:</Typography>
                    </div>
                    <div style={{width: "400px"}}>
                        <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{billConfigurationBuffer.get("V3APIUrl") ?? "--"}</Typography>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", width: "100%", marginTop: "20px"}}>
                    <CCButton
                        className={css_buttons.blueStandardButton}
                        style={{cursor: "pointer", height: "35px", width: "150px"}}
                        size="small"
                        animate={backgroundOperation}
                        onClick={() => {
                            setShowConfigurationEditor(true);
                        }}>
                        <Typography style={{margin: "0 0 0 6px", fontSize: "13px", fontWeight: 500, color: "#FFFFFF"}}>{billConfigurationBuffer.size === 0 ? "New" : "Edit"} Configuration</Typography>
                    </CCButton>
                    {renderEditor()}
                </div>
            </div>
            <div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", width: "100%", marginTop: "50px"}}>
                    <BillSubscriptionTableApplet enterpriseComponent={billConfigurationEnterpriseObject.getEnterpriseComponent("BillSubscription")} />
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", width: "100%", marginTop: "50px"}}>
                    <BillSubscriptionCommunicationTableApplet enterpriseComponent={billConfigurationEnterpriseObject.getEnterpriseComponent("BillSubscriptionCommunication")} />
                </div>
            </div>
        </div>
    );
}